const apptStatus = {
    Pending: 0,
    Accepted: 1,
    Requested: 2,
    DeclinedByInterpreter: 3,
    DeclinedBySystem: 4,
  };
  
  export default apptStatus;